<template>
  <div @click="onReplyEvent(item)">
    <div class="item-container">
      <div class="avatar-container">
        <img class="item-avatar" :src="item.avatar" />
        <img
          class="icon_header_v"
          src="@/static/ic_v_log.png"
          v-if="item.isAuthor"
        />
      </div>
      <div class="right-continer">
        <div class="S8 T1 title-container">
          {{ item.nickname }}
          <span class="item-owner C5 S2 B_C6" v-if="showOwner"> 楼主 </span>
        </div>
        <div class="S8 item-comment" :class="commentColor">
          {{ item.content }}
          <span v-if="item.parentComent">
            <span class="T1"> // </span>
            <span class="C5">{{ '@' + item.parentComent.nickname + ':' }}</span>
            <span :class="parentCommentColor">{{
              item.parentComent.content
            }}</span>
          </span>
        </div>
        <div class="timer-container">
          <div class="S4 T3">
            {{ item.createTime }}
          </div>
          <div class="item-replay" style="padding:0 5px">
            <div class="S4 T1">{{ replyTitle }}</div>
          </div>
        </div>

        <div
          class="delete-container"
          v-if="canDelete"
          @click.stop="onDeleteEvent(item)"
        >
          <div class="btn-delete S2 T1">删除</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import status from '@/api/appInfo'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Dialog } from 'vant'
dayjs.extend(utc)

export default {
  name: 'comment-item',

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },

    showReplyCount: {
      type: Boolean,
      default: false
    },

    showDelete: {
      type: Boolean,
      default: true
    },

    showOwner: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    replyTitle() {
      if (this.showReplyCount) {
        return this.item.replyCount + ' 回复'
      } else {
        return '回复'
      }
    },

    commentColor() {
      if (this.item.isAuthor) {
        return 'C9'
      } else {
        return 'T1'
      }
    },

    parentCommentColor() {
      if (this.item.parentComent.isAuthor) {
        return 'C9'
      } else {
        return 'T1'
      }
    },

    canDelete() {
      return status.appInfoResp.uid == this.item.userId && this.showDelete
    }
  },

  methods: {
    dayjs,
    onReplyEvent(item) {
      this.$emit('onReplyEvent', item)
    },

    onDeleteEvent(item) {
      Dialog.confirm({
        title: '提示',
        message: '确定删除这条评论吗？',
        confirmButtonColor: '#046bcc',
        cancelButtonColor: '#999'
      })
        .then(() => {
          this.$emit('onDeleteEvent', item)
        })
        .catch(() => {
          console.log('你点击了confirm的取消')
        })
    }
  },

  mounted() {}
}
</script>

<style scoped>
.item-container {
  position: relative;
  display: flex;
  flex-direction: row;
}

.avatar-container {
  height: 71px;
  width: 71px;
  position: relative;
  margin-top: 40px;
  margin-left: 30px;
}

.item-avatar {
  height: 71px;
  width: 71px;
  border-radius: 35px;
}

.icon_header_v {
  width: 26px;
  height: 26px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}

.right-continer {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-top: 42px;
  position: relative;
  width: 100%;
}

.title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.item-comment {
  margin-top: 12px;
}

.item-owner {
  padding: 5px;
  background-color: #e8f0fa;
  border-radius: 5px;
  margin-left: 5px;
  height: 20px;
  line-height: 20px;
}

.timer-container {
  margin-top: 12px;
  display: flex;
  flex-direction: row;
}

.item-replay {
  height: 34px;
  line-height: 34px;
  border-radius: 17px;
  margin-left: 20px;
  background-color: #e9e9e9;
  display: flex;
  flex-direction: row;
  padding: 0 30rpx;
}

.delete-container {
  position: absolute;
  top: 0;
  right: 10px;
  width: 100px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.btn-delete {
  border: 1px solid #262626;
  border-radius: 15px;
  text-align: center;
  width: 60px;
  height: 30px;
}
</style>
